/*
Ashraf 01/20/2023 2698088984 added form for view candidates
sai krishna 01/25/2023 2698088984 added batch name and account number
Ravi 06/26/2023 2698088984 fixed submit issue
*/

import React, {useEffect, useContext, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button} from '@material-ui/core';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {fetchClientParentData, getDropDownData} from '../../../../../redux/reducers/AddPatient';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {useHistory} from 'react-router';
import GetAccessMethodFields from './DynamicFields';
import {Formik, Form} from 'formik';
import {ArrowBack} from '@material-ui/icons';
import {createYupSchema} from './YupSchemaCreator';
import {
  fetchBatchAccounts,
  postNewAccountDetails,
  resetData,
  resetMessage,
} from '../../../../../redux/reducers/accountBatch';
import BreadCrums from '../../../../../util/BreadCrum';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import moment from 'moment';

export default function CreateAccount() {
  const history = useHistory();
  const BatchName = history?.location?.state?.BatchName;
  const BatchId = history?.location?.state?.BatchId;
  const accountNumber = history?.location?.state?.accountNumber;
  const ClosedTab = history?.location?.state?.closedBatch;
  const currentTab = history?.location?.state?.tabValue;
  const [fields, setFields] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [validations, setValidations] = useState([]);

  const {roleData} = useSelector(({role}) => role);
  const roleAccess = roleData?.window?.['New Business Maintenance']?.['NBM'];

  const {batchData, batchHeaders, updateStatus, successMsg, errorMsg, isLoading} = useSelector(
    ({accountBatch}) => accountBatch,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const dispatch = useDispatch();

  const yepSchema = validations?.reduce((schema, config) => createYupSchema(schema, config), {});

  const validationSchema = Yup.object().shape(yepSchema);

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  useEffect(() => {
    dispatch(fetchClientParentData());
    dispatch(getDropDownData());
  }, []);

  useEffect(() => {
    if (updateStatus === 200) {
      dispatch(fetchBatchAccounts(accountNumber, BatchId));
    }
  }, [updateStatus]);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (errorMsg) {
    }
  }, [errorMsg]);
  const onSubmit = (data) => {
    if (data) {
      dispatch(submissionStart());
      dispatch(postNewAccountDetails(BatchId, accountNumber, data));
    }
  };

  useEffect(() => {
    const fields = [];
    const initialValues = {};

    batchHeaders &&
      batchHeaders?.map((i) => {
        fields?.push({
          fieldType: i?.fieldType?.toLowerCase(),
          fieldName: i?.fieldCode,
          fieldLabel: i?.fieldHeader,
        });
        initialValues[i?.fieldCode] =
          i?.fieldType?.toLowerCase() === 'date' && batchData[i?.fieldCode?.toLowerCase()] ? 
            moment(batchData[i?.fieldCode?.toLowerCase()]).format('MM/DD/YYYY') : 
            batchData[i?.fieldCode?.toLowerCase()] ? batchData[i?.fieldCode?.toLowerCase()] : i?.fieldType?.toLowerCase() === 'date' ? null : '';
      });
    setInitialValues(initialValues);
    setFields(fields);
    setValidations(fields);
  }, [batchData, batchHeaders]);

  return (
    <>
      {
        <div className="table-header ml-2 mb-3 new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn`}
            onClick={() => {
              dispatch(resetData());
              history.push({
                pathname: '/batch-account-list',
                state: {
                  BatchName: history?.location?.state?.BatchName,
                  closedBatch: ClosedTab === 'Yes' ? 'Yes' : 'No',
                  tabValue: currentTab,
                  BatchId:history?.location?.state.BatchId,
                },
              });
            }}
          >
            <ArrowBack className="mr-1" />
            Back to Account List
          </Button>
        </div>
      }
      <div className="new-standard-textfields">
        <Formik
          onSubmit={(values) => onSubmit(values)}
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {(props) => {
            const {values, setFieldValue, resetForm} = props;
            return (
              <>
                <Form autoComplete="off" noValidate>
                  <div className=" ml-2">
                    <BreadCrums
                      name={'Batch Name'}
                      code={BatchName}
                      description={'Account Number '}
                      descriptionValue={accountNumber}
                    />
                  </div>
                  <div className="global-field-textfields ml-2 new-standard-textfields">
                    <div className="form-row">
                      <GetAccessMethodFields
                        values={values}
                        formProps={props}
                        reportDialogData={{}}
                        setFieldValue={setFieldValue}
                        accessMethodFields={fields}
                        setShowRuleGroupSearch={''}
                        fieldCodeValue={''}
                        additionalInfoData={{}}
                        renderedFrom={'Run Report'}
                      />
                    </div>
                    {fields && fields?.length > 0 && (
                      <div className="row justify-content-center">
                        <Button
                          variant="outlined"
                          className={`reset-btn mr-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            resetForm(initialValues);
                          }}
                          disabled={ClosedTab === 'Yes'}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          disabled={
                            ClosedTab === 'Yes' ||
                            (!roleAccess?.edit && !roleAccess?.add) ||
                            enabledSubmission
                          }
                          className={`search-btn ml-1 ${classes.buttonRoot} `}
                        >
                          Save
                        </Button>
                      </div>
                    )}
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </>
  );
}
